/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('site.carousel', function (el) {
        if (el.id === 'events__carousel') {
            Carousel.handleEventlist(el);
            window.addEventListener('resize', function () {
                Carousel.handleEventlist(el);
            }, true);
        }
        if (el.id === 'custom__banner__carousel') {
            Carousel.handleCustomBanner(el);
        }
    });
    var Carousel = /** @class */ (function () {
        function Carousel() {
        }
        Carousel.handleEventlist = function (el) {
            if (document.body.clientWidth > 992 || el.classList.contains('swiper-container')) {
                return;
            }
            el.classList.add('swiper-container');
            el.querySelector('.eventList').classList.add('swiper-wrapper');
            el.querySelectorAll('.calendar__event').forEach(function (event) {
                event.classList.add('swiper-slide');
            });
            var selector = '#' + el.id;
            MoyaLoader.all([
                'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
                'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
            ]).then(function () {
                new swiper.Swiper(selector, {
                    direction: 'horizontal',
                    spaceBetween: 23,
                    slidesPerView: 1.3,
                    breakpoints: {
                        580: {
                            slidesPerView: 3,
                        },
                        992: {
                            slidesPerView: 5,
                            enabled: false
                        },
                    },
                });
            });
        };
        Carousel.handleCustomBanner = function (el) {
            el.classList.add('swiper-container');
            el.querySelector('.custom__banner__wrapper').classList.add('swiper-wrapper');
            el.querySelectorAll('.item').forEach(function (event) {
                event.classList.add('swiper-slide');
            });
            var selector = '#' + el.id;
            MoyaLoader.all([
                'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
                'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
            ]).then(function () {
                new swiper.Swiper(selector, {
                    direction: 'horizontal',
                    spaceBetween: 0,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                    },
                    autoplay: {
                        delay: 10000,
                    },
                    loop: false,
                    speed: 1500,
                });
            });
        };
        return Carousel;
    }());

}(window));
typeof tsBuild === 'function' && tsBuild();})();
